import React from "react";

const ResumePage = () => {
	return (
		<div>
			<h1>Resume Page</h1>
		</div>
	);
};

export default ResumePage;
